var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('transition-group',{staticClass:"main__container container",style:(_vm.translate),attrs:{"tag":"div","name":"fade","mode":"in-out"}},_vm._l((_vm.filteredJobList),function(ref){
      var id = ref.id;
      var isNew = ref.new;
      var logo = ref.logo;
      var role = ref.role;
      var level = ref.level;
      var tools = ref.tools;
      var company = ref.company;
      var postedAt = ref.postedAt;
      var featured = ref.featured;
      var contract = ref.contract;
      var location = ref.location;
      var position = ref.position;
      var languages = ref.languages;
return _c('JobItem',{key:id,attrs:{"isNew":isNew,"logo":logo,"role":role,"level":level,"tools":tools,"company":company,"postedAt":postedAt,"location":location,"contract":contract,"featured":featured,"position":position,"languages":languages}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }